module.exports = __webpack_public_path__ + "static/media/register1.e0fc7b39.jpg";